import { render, staticRenderFns } from "./Ig.vue?vue&type=template&id=8bd14a88&scoped=true"
import script from "./Ig.vue?vue&type=script&lang=js"
export * from "./Ig.vue?vue&type=script&lang=js"
import style0 from "./Ig.vue?vue&type=style&index=0&id=8bd14a88&prod&lang=scss"
import style1 from "./Ig.vue?vue&type=style&index=1&id=8bd14a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd14a88",
  null
  
)

export default component.exports